module.exports = __webpack_public_path__ + "static/node-3ba5364e6df9819c2fd7924c559cee7b.svg";